import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getParcelDimensionsDisplay } from "@redotech/redo-fulfillment-parcel-common/parcel";
import { getParcelName } from "./fulfillment-group-csv-utils";

export const ParcelSelectionCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Selected parcel",
    cell: (row) => {
      if (!row.selectedParcels?.length) {
        return "No parcel selected";
      }
      return row.selectedParcels
        .map((p) => {
          const name = getParcelName(p);
          const dims = getParcelDimensionsDisplay(p);
          return dims ? `${name} · ${dims}` : name;
        })
        .join(", ");
    },
  };
